import { Component } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { DeliberyNoteServices } from "../../services";
import { ProvidersServices } from "../../../providers/services";
import { DeliberyNoteCreateSelectIngprodPage } from "../delibery-note-create-select-ingprod/delibery-note-create-select-ingprod";
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { CompCreateProviderPage } from '../../../components/popups/create-provider/create-provider';

/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */

@Component({
  selector: 'page-delibery-note-create-select-provider',
  templateUrl: 'delibery-note-create-select-provider.html',
})
export class DeliberyNoteCreateSelectProviderPage {
  public form: FormGroup;
  update_state: boolean = false;
  delibery_note_uid: string;
  origin: any = self;
  p_uid: any;
  p_name: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public deliberyNoteServices: DeliberyNoteServices,
    public translate: TranslateService,
    public analyticsService: AnalyticsServices,
    public modalCtrl: ModalController) {

    //Params
    this.update_state = this.navParams.get('update_state');
    this.delibery_note_uid = this.navParams.get('delibery_note_uid');
    this.origin = this.navParams.get('origin');
    //d
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-proveedores')
    });
    loadingPopup.present();
    this.providersServices.getListProviders(this.globals.restaurant_uid);
    loadingPopup.dismiss();

    this.form = fb.group({
      provider: [this.navParams.get('provider_static'), Validators.compose([Validators.required])],
      date: [this.navParams.get('date'), Validators.compose([Validators.required])],
      number: [this.navParams.get('number'), Validators.compose([Validators.required])],
    });
  }

  ionViewWillEnter() {
  }

  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-rellena-todos-datos'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  async insert() {
    var pro = this.form.value.provider.split(',;,');
    this.p_name = pro[1];
    this.p_uid = pro[0];
    var uid_provider_order = "";

    if (this.navParams.get('origin') == 'provider_order') {
      uid_provider_order = this.navParams.get('uid_provider_order');
    }

    try {
      // Verificar si ya hay un borrador activo
      if (this.deliberyNoteServices.currentDraftDeliveryNote) {
        // Reutilizar albarán existente y actualizar directamente
        this.delibery_note_uid = this.deliberyNoteServices.currentDraftDeliveryNote;
        
        // Actualizar directamente los campos
        await this.deliberyNoteServices.afs.collection('delibery_note')
          .doc(this.delibery_note_uid)
          .update({
            'uid_provider': this.p_uid,
            'provider_static': this.p_name,
            'date': new Date(this.form.value.date),
            'number': this.form.value.number,
            'uid_provider_order': uid_provider_order,
            'waiter': this.globals.waiter,
            'updated_at': new Date()
          });
      } else {
        // Crear nuevo albarán
        const docRef = await this.deliberyNoteServices.afs.collection('delibery_note').add({
          'UID_RESTAURANT': this.globals.restaurant_uid,
          'uid_provider': this.p_uid,
          'provider_static': this.p_name,
          'date': new Date(this.form.value.date),
          'number': this.form.value.number,
          'uid_provider_order': uid_provider_order,
          'waiter': this.globals.waiter,
          'list': [],  // Array vacío inicial
          'state': 'draft',  // Marcar como borrador hasta finalizar
          'created_at': new Date(),
          'total': 0
        });

        this.delibery_note_uid = docRef.id;
        this.deliberyNoteServices.currentDraftDeliveryNote = docRef.id;
        this.deliberyNoteServices.currentCreationMethod = 'manual';
      }

      this.globals.GAtrackView('Stock', 'Stock - Delibery note - Select provider - Create',
        this.globals.restaurant.email, 'Create/Update',
        'Create select provider delibery note', 'Stock', this.form.value.number);

      // Enviar tracking de creación (no crítico, no bloquear)
      this.analyticsService.trackingExpStock('create_delivery_note', this.globals.tracking_exp['create_delivery_note'], this.delibery_note_uid).catch(err => {
        console.warn('[Albarán] Error tracking create_delivery_note (no crítico):', err);
      });

      const latestNoteSnapshot = await this.deliberyNoteServices.afs.collection('delibery_note').doc(this.delibery_note_uid).ref.get();
      const latestNote = latestNoteSnapshot.exists ? latestNoteSnapshot.data() : null;

      await this.deliberyNoteServices.getLatestDeliveryNote(latestNote);

      if (latestNote) {
        this.deliberyNoteServices.notifyDeliveryNoteUpdated();
      }

      if (this.navParams.get('origin') == 'provider_order') {
        var list = this.navParams.get('list');
        this.deliberyNoteServices.prodings_array_tmp = [];

        for (let element of list) {
          this.deliberyNoteServices.prodings_array_tmp.push([
            element.uid, element.name, element.type, element.price,
            element.measurement, element.tax, element.quantity, 0,
            element.total, element.tax, element.uid, element.lots,
            'discount_percentage'
          ]);
        }

        await this.deliberyNoteServices.afs.collection('provider_order')
          .doc(this.navParams.get('uid_provider_order'))
          .update({
            'delivery_note': true,
            'uid_delibery_note': this.delibery_note_uid,
            'state': 'completed',
          });

        this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Link delibery note - Create',
          this.globals.restaurant.email, 'Create/Update', 'Create provider order', 'ProviderOrders', '');

        this.navCtrl.push(DeliberyNoteCreateSelectIngprodPage, {
          update_state: false,
          delibery_note_uid: this.delibery_note_uid,
          origin: 'provider_order',
          provider_name: this.p_name,
          provider_uid: this.p_uid,
        });

      } else {
        this.navCtrl.push(DeliberyNoteCreateSelectIngprodPage, {
          update: false,
          delibery_note_uid: this.delibery_note_uid,
          provider_name: this.p_name,
          provider_uid: this.p_uid,
        });
      }

    } catch (error) { }
  }

  update() {
    var pro = this.form.value.provider.split(',;,');
    this.p_name = pro[1];
    this.p_uid = pro[0];

    this.deliberyNoteServices.afs.collection('delibery_note').doc(this.delibery_note_uid).update({
      'uid_provider': this.p_uid,
      'provider_static': this.p_name,
      'date': new Date(this.form.value.date),
      'number': this.form.value.number,
    }).then(() => {
      this.globals.GAtrackView('Stock', 'Stock - Delibery note - Select provider - Update', this.globals.restaurant.email, 'Create/Update', 'Update  select provider delibery note', 'Stock', this.form.value.number);
      this.navCtrl.pop();
    });
  }

  createProvider() {
    if (this.globals.checkLimitsByLicense('stock', 'providers') != -1) {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      //open create provider
      let profileModal = this.modalCtrl.create(CompCreateProviderPage, {
        origin: 'delibery-note'
      });
      profileModal.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-create-select-provider/delibery-note-create-select-provider.ts